import { cn } from "@/lib/utils";

/**
 * Patrón compartido: zona de título a la izquierda y carril fijo (w-10, borde izq.)
 * con chevron hacia abajo que rota al expandir — mismos criterios que hubs / visor / AccordionTrigger.
 */

const MAIN_BASE =
  "flex min-w-0 flex-1 items-center gap-2 px-4 py-3 text-left text-sm font-semibold text-slate-900 transition-colors";

const TOGGLE_BASE =
  "relative z-20 flex w-10 shrink-0 items-center justify-center self-stretch border-l border-slate-200 text-slate-600 transition-colors hover:bg-slate-100 hover:text-slate-900";

const MAIN_COMPACT =
  "flex min-w-0 flex-1 items-center gap-1.5 px-3 py-1.5 text-left text-xs font-semibold text-slate-900 transition-colors";

const TOGGLE_COMPACT =
  "relative z-20 flex w-8 shrink-0 items-center justify-center self-stretch border-l border-slate-200 text-slate-600 transition-colors hover:bg-slate-100 hover:text-slate-900";

export const satExpandRowCn = (extra) =>
  cn("flex w-full min-w-0 items-stretch gap-0 min-h-[2.75rem]", extra);

export const satExpandRowCompactCn = (extra) =>
  cn("flex w-full min-w-0 items-stretch gap-0 min-h-[2rem]", extra);

export function satExpandMainCn(expanded) {
  return cn(MAIN_BASE, expanded ? "bg-white" : "bg-slate-50/90 hover:bg-slate-50");
}

export function satExpandMainCompactCn(expanded) {
  return cn(MAIN_COMPACT, expanded ? "bg-white" : "bg-slate-50/90 hover:bg-slate-50");
}

export function satExpandToggleCn(expanded) {
  return cn(TOGGLE_BASE, expanded ? "bg-white" : "bg-slate-50/90");
}

export function satExpandToggleCompactCn(expanded) {
  return cn(TOGGLE_COMPACT, expanded ? "bg-white" : "bg-slate-50/90");
}

export function satExpandChevronCn(expanded) {
  return cn(
    "h-4 w-4 shrink-0 text-slate-500 transition-transform duration-200",
    expanded && "rotate-180"
  );
}

/** Hijos de un trigger Radix Accordion (`group` + `data-state` en el padre). */
export const satExpandMainRadixCn = cn(
  MAIN_BASE,
  "bg-slate-50/90 hover:bg-slate-50 group-data-[state=open]:bg-white"
);

export const satExpandMainRadixCompactCn = cn(
  MAIN_COMPACT,
  "bg-slate-50/90 hover:bg-slate-50 group-data-[state=open]:bg-white"
);

export const satExpandToggleRadixCn = cn(TOGGLE_BASE, "bg-slate-50/90 group-data-[state=open]:bg-white");

export const satExpandToggleRadixCompactCn = cn(TOGGLE_COMPACT, "bg-slate-50/90 group-data-[state=open]:bg-white");

export const satExpandChevronRadixCn =
  "h-4 w-4 shrink-0 text-slate-500 transition-transform duration-200 group-data-[state=open]:rotate-180";
